<template>
  <el-form
    :ref="refer"
    :model="model"
    :label-width="labelWidth"
    :rules="rules"
    :inline="inline"
    :class="classes"
    :label-position="labelPosition"
  >
    <div v-for="(item,index) in formList" :key="index">
      <el-form-item v-if="item.type == 'autocomplete'" :label="item.label" :prop="item.prop">
        <el-autocomplete
          :style="{display:'block'}"
          v-model="model[item.tag]"
          :fetch-suggestions="querySearch"
          placeholder="请输入内容"
          :trigger-on-focus="false"
          @select="handleSelect"
        ></el-autocomplete>
      </el-form-item>
      <el-form-item
        v-else-if="item.type == 'input'"
        :label="item.label"
        :prop="item.prop"
        :class="item.classes"
      >
        <el-input
          v-model="model[item.tag]"
          :name="item.tag"
          :ref="item.tag"
          :placeholder="item.placeholder"
        ></el-input>
      </el-form-item>
      <el-form-item v-else-if="item.type == 'select'" :label="item.label">
        <el-select v-model="model[item.tag]" placeholder="请选择">
          <el-option
            v-for="item in item.options"
            :key="item.value"
            :label="item.label"
            :value="item.value*1"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item v-else-if="item.type == 'button'">
        <el-button
          v-loading="item.loading"
          :class="['submit-btn']"
          v-if="item.type == 'button'"
          :type="item.types || 'primary'"
          @click="submit(item)"
        >{{item.label || '修改'}}</el-button>
      </el-form-item>
      <el-form-item v-else-if="item.type == 'kong'" :class="item.classes"></el-form-item>
    </div>
  </el-form>
</template>

<script>
export default {
  name: "HelloWorld",
  props: {
    labelPosition: {
      type: String,
      default: "right"
    },
    classes: {
      type: String,
      default: ""
    },
    labelWidth: {
      type: String,
      default: "100px"
    },
    formList: {
      type: Array,
      default() {
        return [{ value: "", tag: "" }];
      }
    },
    model: {
      type: Object,
      default() {
        return {};
      }
    },
    inline: {
      type: Boolean,
      default: false
    },
    refer: {
      type: String,
      default: "formList"
    },
    rules: {
      type: Object,
      default() {
        return {};
      }
    }
  },
  data() {
    return {
      restaurants: []
    };
  },
  mounted() {},
  methods: {
    submit(item) {
      this.$refs[this.refer].validate(valid => {
        if (valid) {
          this.$emit("submit", item);
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    loadAll() {
      return [
        // { "value": "三全鲜食（北新泾店）", "address": "长宁区新渔路144号" },
      ];
    },
    paperSearch(k) {
      return this.API.paperSearch({ k }).then(res => {
        if (res.status == 1) {
          res.data.map(item => {
            // title:标题;author:作者;journal:期刊;yeardata:年卷期;keyword:关键词;customize:自定义关键词
            item.value = item.title;
            item.author = item.creatorAll;
            item.yeardata = item.volume;
            item.keyword = item.keyword;
          });
          this.restaurants = res.data;
        }
      });
    },
    handleSelect(item) {
      console.log(item);
      this.$emit("handleSelect", item);
    },
    async querySearch(queryString, cb) {
      var restaurants = this.restaurants;
      var results = queryString;
      // 调用 callback 返回建议列表的数据
      await this.paperSearch(results);
      cb(this.restaurants);
    }
  }
};
</script>

<style  lang='scss'>
.el-form {
  > div {
    display: inline-block;
  }
}
.search-form {
  font-size: 18px;
}
.search-form-center {
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
}
.submit-btn {
  width: 100%;
}
.w500 {
  width: 565px;
  .el-form-item__content {
    width: calc(100% - 130px);
  }
  // .el-input{
  //   width: calc(100% - 120px);
  // }
}
.item-block {
  display: block;
  width: 100%;
  height: 0;
  margin-bottom: 0;
}
</style>



// WEBPACK FOOTER //
// src/components/FormList/index.vue